// src/api/encryptedBaseQuery.js
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import forge from 'node-forge';
 
export const createEncryptedBaseQuery = ({baseUrl,prepareHeaders}) => {
  return async (args, api, extraOptions) => {
    const { url, method = 'GET', body, ...rest } =
      typeof args === 'string' ? { url: args } : args;
 
    if (method === 'GET' || !body) {
      return fetchBaseQuery({ baseUrl,prepareHeaders })(args, api, extraOptions);
    }

    const pubKeyBase64 = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArb7++BxL/YN8OIln+6FL9Gnw5DNmQ/VFZXss+J+TuQyJc891JbqbijxYQNEin2c2u+CnpXpoGQ/1gUSzDMJeNS3sNSlIUykp2dt7xIm/cmV4sZ/c769vCxVRosMfRaZJnBAah+m1X26lEhnOo0wpAB9Txr8RIyBe6h7PiQWykeJeh6UacOBBX28kgkq7+vJhW8HgB38lt32XRocznRYwS9LqR7ZweFmQhTr1+EGrqiEKCOCxMYgHR2SQckb96hZ9kWzfzeun4bUO5oXKJciLkiS1IgKieADEvYLgu129ZIpn1H+8H+8ikNNVETqEDDMtqcQcQmWppJvcWHaXAs+f8QIDAQAB"
    const pubKeyBuffer = Uint8Array.from(atob(pubKeyBase64), c => c.charCodeAt(0));

    const wrapPublicKey = (base64Key) => {
      const lines = base64Key.match(/.{1,64}/g).join("\n");
      return `-----BEGIN PUBLIC KEY-----\n${lines}\n-----END PUBLIC KEY-----`;
    };


    const hybridEncrypt = async (body, pubKeyBuffer,pubKeyBase64) => {
    const isSecureContext = window.crypto?.subtle;
    if(isSecureContext){
      console.log("secure")
     // --- WebCrypto Implementation (HTTPS) ---
    const publicKey = await window.crypto.subtle.importKey(
      "spki",
      pubKeyBuffer,
      { name: "RSA-OAEP", hash: "SHA-256" },
      false,
      ["encrypt"]
    );
    const aesKey = window.crypto.getRandomValues(new Uint8Array(32));
    const iv = window.crypto.getRandomValues(new Uint8Array(12));
    const aesKeyObj = await window.crypto.subtle.importKey(
      "raw",
      aesKey,
      "AES-GCM",
      false,
      ["encrypt"]
    );
    const encodedBody = new TextEncoder().encode(JSON.stringify(body));
    const encryptedPayload = await window.crypto.subtle.encrypt(
      { name: "AES-GCM", iv },
      aesKeyObj,
      encodedBody
    );
    const encryptedAesKey = await window.crypto.subtle.encrypt(
      { name: "RSA-OAEP" },
      publicKey,
      aesKey
    );
    return {
      encryptedPayload: btoa(String.fromCharCode(...new Uint8Array(encryptedPayload))),
      encryptedKey: btoa(String.fromCharCode(...new Uint8Array(encryptedAesKey))),
      iv: btoa(String.fromCharCode(...iv)),
    };
  }else {
      // --- Node-Forge Fallback (HTTP or unsupported browser) ---
      console.log("private or HTTP or unsupported browser  ")
      const pemkey = wrapPublicKey(pubKeyBase64)
      const rsa = forge.pki.publicKeyFromPem(pemkey);
      
      const aesKey = forge.random.getBytesSync(32);
      const iv = forge.random.getBytesSync(12);
   
      const cipher = forge.cipher.createCipher('AES-GCM', aesKey);
      cipher.start({ iv });
     cipher.update(forge.util.createBuffer(JSON.stringify(body), 'utf8'));
      cipher.finish();
   
      const encryptedPayload = cipher.output.getBytes();
      const tag = cipher.mode.tag.getBytes()
      // const encryptedKey = rsa.encrypt(aesKey, 'RSA-OAEP');
      const fullencryption = encryptedPayload + tag;
      const encryptedKey = rsa.encrypt(aesKey, 'RSA-OAEP', {
        md: forge.md.sha256.create()
          });
   
      return {
        encryptedPayload: btoa(fullencryption),
        encryptedKey: btoa(encryptedKey),
        iv: btoa(iv),
      };
    }
}

     const encryptedBody = await hybridEncrypt(body, pubKeyBuffer,pubKeyBase64);
 
    const newArgs = {
      url,
      method,
      body: encryptedBody,
      headers: {
        'Content-Type': 'application/json',
      },
      ...prepareHeaders,
      ...rest,
    };
 
    return fetchBaseQuery({ baseUrl,prepareHeaders })(newArgs, api, extraOptions);
  };
};